<template>
  <div>
    <div class="top-content">
      <button
        class="buto"
        @click="$router.back()"
      >返回</button>

      <button
        class="buttons cwbf"
        style="background-color: aqua;"
        @click="setupShow =true"
      >创建队伍</button>

      <button
        class="buto"
        style="background-color:coral"
        @click="onTarget()"
      >移至队伍</button>
    </div>

    <div class="detail">
      <div
        class="css-display"
        v-for="(item,index) in List"
        :key="index"
      >
        <div>
          <span style="float:right">
            <van-checkbox
              icon-size="18"
              v-model="item.checkeds"
              @click="tempArrives(item.checkeds,item.list)"
            >全选</van-checkbox>
          </span>
          <span style="font-weight: 700;font-size: 17px;">{{item.business_name}}</span>
          <span style="font-weight: 700;font-size: 15px;"> ({{item.ct}}人)</span>
        </div>

        <van-row class="box-content">
          <van-col span="2">勾选</van-col>
          <van-col span="5">队伍</van-col>
          <van-col span="5">姓名</van-col>
          <van-col span="3">性别</van-col>
          <van-col span="8">电话</van-col>
        </van-row>

        <div
          v-for="(item2,index2) in item.list"
          :key="index2"
        >
          <van-row class="box-content">
            <van-col span="2">
              <van-checkbox
                icon-size="18"
                v-model="item2.checked"
                @click="temlChe(index)"
              />
            </van-col>
            <van-col span="5">{{item2.team||'-'}}</van-col>
            <van-col span="5">{{item2.real_name}}</van-col>
            <van-col span="3">{{item2.sex=='man'?'男':'女'}}</van-col>
            <van-col span="8">{{item2.mobile_no||'暂无电话'}}</van-col>
          </van-row>
        </div>

      </div>
    </div>

    <div class="footers">
      <button
        class="buttons cwbf"
        style="background-color: aqua;"
        @click="goGroups()"
      >队伍管理</button>
      <button
        class="buttons cwbf"
        style="background-color: aqua;"
        @click="goPeople()"
      >伙伴管理</button>

      <!-- <button
        class="buttons cwbf"
        style="background-color: aqua;"
        @click=""
      >自动分配</button> -->
    </div>

    <van-popup
      v-model="showCities"
      position="bottom"
      :closeable="true"
      style="height:92vh"
    >
      <div style="width: 92%;height: 95%;margin-left: 15px;margin-top: 15px;">

        <!-- 标题 -->
        <div style="text-align: center;font-size: 20px;font-weight: 500;">
          移至队伍
        </div>
        <!-- /标题 -->

        <div class="roll">
          <!-- 可选小队 -->
          <div
            v-for="(tItem,tIndex) in targetList"
            :key="tIndex"
          >
            <van-cell-group>
              <van-cell
                :title="tItem.team2.name"
                style="font-size: 18px;font-weight: 700;"
              />
            </van-cell-group>
            <div class="town">
              <div
                v-for="(item2,index2) in tItem.team3_list"
                :key="index2"
                style="display: inline-block;margin-top: 10px;"
                @click="onConfirm(item2)"
              >
                <van-tag
                  style="font-size: 14px;border-radius: 10px;"
                  :color="target===item2.name?'#FF9900':'#ffffff'"
                  :text-color="target===item2.name?'#ffffff':'#999999'"
                >{{item2.name}}</van-tag>

              </div>
            </div>

          </div>
          <!-- /可选小队-->

        </div>

        <div style="display:flex;justify-content: space-between;">
          <button
            class="buttons"
            style="background-color: #ee0a24;width: 100%;"
            @click="onSubmit()"
          >确定</button>
        </div>

      </div>
    </van-popup>

    <van-dialog
      v-model="setupShow"
      title="创建队伍"
      show-cancel-button
      width="250"
      @cancel="setupShow=false"
      @confirm="setupConfirm()"
    >
      <div>
        <van-cell-group>
          <van-field
            v-model="bigGroupValue"
            label="大队数量"
            type="digit"
            label-width="150"
            input-align="center"
            placeholder="请输入大队数量"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="middleGroupValue"
            label="每个大队下中队数量"
            type="digit"
            input-align="center"
            label-width="150"
            placeholder="请输入大队数量"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="smallGroupValue"
            label="每个中队下小队数量"
            type="digit"
            input-align="center"
            label-width="150"
            placeholder="请输入大队数量"
          />
        </van-cell-group>
      </div>
    </van-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      project_id: '',
      op: '',
      setupShow: false,
      List: [],
      showCities: false,
      targetList: [],
      target: '',
      target_id: '',
      checkedList: [],
      bigGroupValue: 1,
      middleGroupValue: 1,
      smallGroupValue: 1,
    }
  },
  created() {
    this.project_id = this.$route.query.project_id
    this.getList()
    this.getTarget()
  },
  methods: {
    // 跳转到伙伴管理
    goPeople() {
      this.$router.push({
        path: '/partnerAdmin',
        query: {
          project_id: this.project_id,
        },
      })
    },
    // 跳转到队伍管理
    goGroups() {
      this.$router.push({
        path: '/groupsAdmin',
        query: {
          project_id: this.project_id,
        },
      })
    },
    // 获取渠道还有孩子信息
    getList() {
      this.$axios
        .get('project/business-order-list', {
          params: {
            project_id: this.project_id,
          },
        })
        .then((res) => {
          let data = res.data.data

          for (let j = 0; j < data.length; j++) {
            data[j].checkeds = 0
            for (let k = 0; k < data[j].list.length; k++) {
              data[j].list[k].checked = 0
            }
          }
          //  /将对象进行特殊处理
          console.log(data)

          this.List = data
        })
    },
    // 获取所有小队数据
    async getTarget() {
      const res = await this.$axios.get('/project/team-list', {
        params: {
          project_id: this.project_id,
        },
      })

      if (res.data.code != 200) {
        this.$toast(res.data.msg)
        return
      }
      this.targetList = res.data.data
    },
    onTarget() {
      let checkedList = []
      // 将 所有checked 为true 或者1的数据的id添加到需要提交的数组
      for (let i = 0; i < this.List.length; i++) {
        for (let j = 0; j < this.List[i].list.length; j++) {
          if (this.List[i].list[j].checked) {
            checkedList.push(this.List[i].list[j].id)
          }
        }
      }
      if (checkedList.length == 0) {
        this.$toast('请选择需要调整小队的孩子')
        return
      }

      this.checkedList = checkedList

      this.showCities = true
    },
    // 确认 请求分配到指定小队
    async onSubmit() {
      const res = await this.$axios.post('/project/team-switch', {
        ids: this.checkedList,
        team3_id: this.target_id,
      })
      setTimeout(() => {
        this.$toast(res.data.msg)
        if (res.data.code == 200) {
          this.showCities = false
          this.target = ''
          this.target_id = ''
          this.checkedList = null
          this.getList()
        }
      }, 500)
    },

    // 选中目标小队
    onConfirm(item) {
      this.target = item.name
      this.target_id = item.id
    },

    tempArrives(newV, item) {
      // 勾中全选的情况下
      if (newV) {
        for (let i = 0; i < item.length; i++) {
          item[i].checked = 1
        }
      } else {
        for (let i = 0; i < item.length; i++) {
          item[i].checked = 0
        }
      }
    },
    temlChe(index) {
      // 所有的都选中了那么勾上全选
      let tempValue = this.List[index].list.every((item) => {
        return item.checked > 0
      })
      if (tempValue) {
        this.List[index].checkeds = true
      } else {
        this.List[index].checkeds = false
      }
    },
    setupConfirm() {
      let that = this
      this.$axios
        .post('project/team-init', {
          project_id: this.project_id,
          b_team_qty: this.bigGroupValue,
          m_team_qty: this.middleGroupValue,
          s_team_qty: this.smallGroupValue,
        })
        .then((res) => {
          that.getTarget()
          console.log(res)
          this.$toast(res.data.msg)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.detail {
  padding: 70px 20px;
}
.footers {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 700;
  background-color: #fff;
}

.buttons {
  color: #fff;
  padding: 9px 20px;
  border: none;
  border-radius: 6px;
}
.cwbf {
  color: #000;
  border: 1px solid #666;
}
.top-content {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 700;
  background-color: #fff;
  z-index: 99;
}
.buto {
  vertical-align: top;
  background-color: #ee0a24;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
}
.css-display {
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #f1f1f1;
  padding: 10px;
  font-size: 15px;
  border-radius: 10px;
  box-shadow: 2px 2px 4px rgba($color: #4c4d47, $alpha: 0.5);
  margin-bottom: 10px;
}
.box-content {
  text-align: center;
  margin-top: 5px;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
}
.roll {
  height: 450px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.town {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.town:after {
  content: '';
  width: 100px;
}
/deep/ .van-tag--default {
  width: 85px;
  font-size: 20px;
  padding: 5px;
  text-align: center !important;
  display: block;
  margin-bottom: 8px;
  border: 1px solid #999;
}
/deep/ .van-field__value {
  border: 1px solid #999;
}
</style>